<template>
  <div class="frame" @click="proxyOpen($event)">
    <button class="actionButton" v-on:click="commonDownload($event)">
      {{ downloadBtnText }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { defineEmits, defineProps, withDefaults } from 'vue';
import i18n from '@/i18n';

export interface OpenButtonStyle {
  position?: string;
  left?: string;
  background: string;
  'border-radius': string;
  'border-width': string;
  width: string;
  height: string;
  'font-size': string;
  color: string;
  'text-decoration-line': string;
  'text-align'?: string;
}

export interface RealButtonStyle {
  'font-size': string;
  color: string;
  'text-decoration-line': string;
}

interface OpenButtonProps {
  openBtnStyleObj: OpenButtonStyle;
  downloadBtnText: string;
}

const emit = defineEmits(['actionDownload']);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<OpenButtonProps>(), {
  // openBtnStyleObj: () => ({
  //   background: '#00FF00',
  //   'border-radius': '18px',
  //   'border-width': '0px',
  //   width: '300px',
  //   height: '54px',
  //   'font-size': '18px',
  //   color: '#fff',
  //   'text-decoration-line': 'none',
  // }),
  downloadBtnText: i18n.global.t('common.download'),
});

// const openButtonStyle = computed(() => {
//   return {
//     ...props.openBtnStyleObj,
//   } as CSSProperties;
// });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function proxyOpen(event: any) {
  event.stopPropagation();
  downloadAction();
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function commonDownload(event: any) {
  event.stopPropagation();
  downloadAction();
}

function downloadAction() {
  emit('actionDownload');
}
</script>

<style scoped>
.frame {
  position: relative;
  align-items: center;
  margin: auto;
  width: 280px;
  height: 48px;
  border-radius: 18px;
  /* stylelint-disable-next-line order/properties-order */
  font-size: 16px;
  color: #ffffff;
  background: #3b64fc;
}

.actionButton {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  border-width: 0;
  background-color: transparent;
  /* stylelint-disable-next-line order/properties-order */
  font-size: 16px;
  color: #ffffff;
  text-decoration-line: none;
}

.weixinDiv {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
